// 问卷分析
<template>
  <div
    class="back-color-fff"
    :element-loading-text="loadingText"
    element-loading-custom-class="my-loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <div style="position: relative;height: 85px;background-color: #fff;" >
      <div :class="isVisable ? 'button-area2' : 'button-area'" v-if="surveyReport.length">
        <el-button size="medium" type="info" v-if="reportHTML" @click="dialogVisible = true">导出问卷分析</el-button>
        <el-button size="medium" type="info" v-if="reportHTML" @click="goBack">返回</el-button>
        <el-button size="medium" type="info" v-else @click="btnHTMLtoCanvas2">生成导出报告</el-button>
        <div class="batch-btn" v-if="showBatchBtn">
          <el-form :model="form" label-width="80px">
            <el-form-item label="批量按钮" style="width:100%">
              <el-checkbox-group v-model="form.batchCheckboxGroup" @change="checkBoxChange" size="small">
                <el-checkbox-button v-for="item in charts" :label="item.value" :key="item.value">{{
                  item.label
                }}</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="排序" style="width:100%;">
              <div class="flex-box">
                <el-input v-for="item in charts" class="sort-input-box" v-model="item.orderNo"  type="text"></el-input>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div
      id="report-content"
      style="width: 625px; margin: 0 auto; background-color: #fff; font-family: 宋体"
      ref="reports"
    >
      <div v-show="surveyReport.length > 0" style="font-weight: 700;text-align: center; font-size: 16pt; padding-bottom: 10px; font-family: 宋体"
       v-for="(item, index) in taskDetail">
        {{ item.taskContentName }}({{ item.startTime | getDate }} 至 {{ item.endTime | getDate}})
        
      </div>
      <div style="padding-top: 20px;" v-for="(item, index) in surveyReport" :key="index">
        <TaskItem
          ref="taskItemRef"
          :batchCheckboxGroup="form.batchCheckboxGroup"
          :taskItemData="item"
          :checkboxGroupItem="checkboxGroupList[index]"
          :showBtn="showBtn"
          :index="index"
          :chartsOrder="charts"
        ></TaskItem>
        <br />
      </div>
      <!-- 题目明细 -->
      <!-- <TopicInfo v-if="form.type === 'Y'" :tableDataAll="tableDataAll"></TopicInfo> -->
      <TopicInfo v-if="form.type === 'Y'" :tableDataAll="tableDataAll"></TopicInfo>
      <!-- 导出明细弹框 -->
    </div>
    <el-dialog
      @closed="closedDialog"
      :title="'导出问卷分析'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="450px"
    >
      <div slot="title" class="dialog-title">
        {{ '导出问卷分析' }}
      </div>
      <div class="dialogCon">
        <div class="dialogCon-describe">
          <el-form ref="form" :model="form" label-width="180px">
            <el-form-item label="是否导出问卷明细">
              <el-radio-group v-model="form.type">
                <el-radio label="Y">是</el-radio>
                <el-radio label="N">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="info" @click="confirm">确定</el-button>
      </span>
    </el-dialog>
    <!-- 返回顶部按钮 -->
    <div v-show="isVisable" @click.prevent="toTop" class="toTop">
      <div style="width: 40px; height: 30px; margin: auto">
        <svg width="20" class="to-top-svg" height="24" viewBox="0 0 1024 1024">
          <path
            d="M589.095 202.89l5.872 5.489 387.674 387.674c12.497 12.497 12.497 32.758 0 45.255-11.361 11.361-29.138 12.394-41.666 3.098l-3.589-3.098-387.674-387.674c-1.8-1.8-3.697-3.444-5.673-4.933l-0.039 732.633c0 17.673-14.327 32-32 32-16.2 0-29.589-12.039-31.708-27.658l-0.292-4.342-0.039-732.633c-0.452 0.34-0.899 0.689-1.343 1.045l-4.33 3.888-387.812 387.812c-12.497 12.497-32.758 12.497-45.255 0-11.361-11.361-12.393-29.138-3.098-41.666l3.098-3.589 387.812-387.812c43.912-43.912 113.971-45.742 160.063-5.489zM960 10.667c17.673 0 32 14.327 32 32 0 16.2-12.039 29.589-27.658 31.708l-4.342 0.292h-896c-17.673 0-32-14.327-32-32 0-16.2 12.039-29.589 27.658-31.708l4.342-0.292h896z"
            fill-opacity="0.4"
          ></path>
        </svg>
      </div>
      <div style="width: 80px; font-size: 12px; text-align: center">
        <span>返回顶部</span>
      </div>
    </div>
  </div>
</template>

<script>
import TaskItem from './TaskItem.vue';
import TopicInfo from './TopicInfo.vue';
import html2canvas from 'html2canvas';
import saverFile from 'file-saver';
import $ from 'jquery';
import { reportRoute } from '@/api/apiRoute';
import { $eventBus } from '../utils/eventBus';
export default {
  components: {
    TaskItem,
    TopicInfo,
  },
  props: ['surveyReport', 'currentSurver', 'tableDataAll', 'surveyReportLoading','searchShow','taskDetail'],
  data() {
    return {
      showBatchBtn:true,
      main: null,
      isVisable: false,
      checkboxGroupList: [],
      reportHTML: '',
      loadingText: '报告表格生成中，请勿关闭当前浏览器',
      chartList: [],
      showBtn: true,
      fullscreenLoading: false,
      dialogVisible: false,
      form: {
        type: 'N',
        batchCheckboxGroup:['5','0'],
      },
      charts: [
        {
          value: '0',
          label: '饼状',
          componentName: 'PieChart',
          orderNo: 0,
        },
        {
          value: '1',
          label: '圆环',
          componentName: 'PieChart',
          orderNo: 1,
        },
        {
          value: '2',
          label: '柱状',
          componentName: 'BarChart',
          orderNo: 2,
        },
        {
          value: '3',
          label: '条形',
          componentName: 'BarChart',
          orderNo: 3,
        },
        {
          value: '4',
          label: '折线',
          componentName: 'LineChart',
          orderNo: 4,
        },
        {
          value: '5',
          label: '表格',
          componentName: 'TableChart',
          orderNo: 5,
        },
        {
          value: '6',
          label: '文字汇总',
          componentName: 'TextChart',
          orderNo: 6,
        },
      ],
    };
  },
  created() {
    $eventBus.$on('setCheckGroup', () => {
      if (localStorage.checkboxGroupList) {
        this.checkboxGroupList = JSON.parse(localStorage.checkboxGroupList);
      }
    });
    if(sessionStorage.oldCharts){
      this.charts = JSON.parse(sessionStorage.oldCharts);
      this.form = JSON.parse(sessionStorage.oldForm);
      sessionStorage.removeItem('oldCharts');
      sessionStorage.removeItem('oldForm');
    }
  },
  mounted() {
    $('.el-main').scroll((e) => {
      // debugger
      let scrollTop = e.target.scrollTop;
      this.windowScrollListener(scrollTop);
    });
  },
  watch: {
    surveyReportLoading: {
      immediate: true,
      handler(newVal) {
        this.fullscreenLoading = newVal;
      },
    },
    
  },
  computed: {},
  methods: {
    checkBoxChange(val) {
      // $eventBus.$emit('batchSetCheckGroup',{batchCheckboxGroup:this.batchCheckboxGroup});
    },
    //监听窗口滚动
    windowScrollListener(scrollTop) {
      //获取操作元素最顶端到页面顶端的垂直距离
      if (this.searchShow) {
        if (scrollTop >= 195) {
          this.isVisable = true; 
        }
        if (scrollTop < 195) {
          this.isVisable = false; 
        }
      } else {
        if (scrollTop >= 150) {
          this.isVisable = true; 
        }
        if (scrollTop < 150) {
          this.isVisable = false;
        }
      }
    },
    toTop() {
      $('.el-main').animate({ scrollTop: 0 }, 'fast');
    },
    closedDialog() {},
    confirm() {
      this.dialogVisible = false;
      if (this.form.type && this.form.type === 'Y') {
        // 带明细的导出
        this.$nextTick(() => {
          this.exportWord();
        });
      } else if (this.form.type && this.form.type === 'N') {
        // 不带明细的导出
        this.$nextTick(() => {
          this.exportWord();
        });
      } else {
        this.$message.waring('请勾选导出类型');
      }
    },
    // !根据checkboxGroup的的值进行匹配
    getChartList() {
      let taskItemList = this.$refs.taskItemRef || [];
      if (taskItemList.length) {
        taskItemList.forEach((item) => {
          const { exportChartList , checkboxGroup } = item
          if (Object.keys(exportChartList).length && checkboxGroup.length) {
            let chartCodeList = Object.keys(exportChartList)
            let resArr = chartCodeList.filter(chartItem=>checkboxGroup.some(checkCode=>checkCode === chartItem));
            // #获取勾选的chart
            resArr.forEach(item=>{
             if (exportChartList[item]) this.chartList.push(exportChartList[item]);
            })
          }
        });
      }
    },
    exportWord() {
      this.fullscreenLoading = true;
      this.getChartList()
      this.$nextTick(() => {
        // let htmls = document.getElementById('report-content'); //获取需要导出的标签
        let htmls = this.$refs['reports']; //获取需要导出的标签
        this.convertChartsToBase64(htmls);
        this.saveReportResult(htmls.innerHTML);
        // this.saveReportResult2(htmls.innerHTML);
        // this.saveReportResult3(htmls.innerHTML);
        // this.saveReportResult4(htmls.innerHTML);
      });
    },
    convertChartsToBase64(contentDocument) {
      // 找到所有的图表 （echart）
      let canvases = contentDocument.querySelectorAll('canvas');
      // 遍历图表，转换为 base64 静态图片
      canvases.forEach((canvas, i) => {
        let opts = {
          type: 'jpeg', // 导出的格式，可选 png, jpeg
          pixelRatio: 1, // 导出的图片分辨率比例，默认为 1。
          backgroundColor: '#fff', // 导出的图片背景色，默认使用 option 里的 backgroundColor
        };
        let echart = this.chartList[i];
        let url = echart.getDataURL(opts);
        let img = document.createElement('img');
        if (url) {
          // img.src = url.split(',')[1];
          img.src = url;
          img.width = 625;
          img.height = 400;
        }
        canvas.parentNode.replaceChild(img, canvas);
      });
    },
    // 按钮区域转换成canvas
    async btnHTMLtoCanvas() {
      this.fullscreenLoading = true;
      let contentDocument = $.clone(this.$refs['reports']); //获取需要导出的标签
      let taskItemList = this.$refs['taskItemRef'];
      for (let index = 0; index < taskItemList.length; index++) {
        const item = taskItemList[index];
        let element = item.$refs.itemHeadBbtnRef;
        let eleOffsetTop = element.offsetTop; // 获得该容器到文档顶部的距离
        let eleOffsetLeft = element.offsetLeft; // 获得该容器到文档最左的距离
        let abs = 0;
        let win_in = document.documentElement.clientWidth || document.body.clientWidth; // 获得当前可视窗口的宽度（不包含滚动条）
        let win_out = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）
        if (win_out > win_in) {
          // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
          abs = (win_out - win_in) / 2; // 获得滚动条宽度的一半
          // console.log(a, '新abs');
        }
        let canvas = document.createElement('canvas');
        let eleW = element.offsetWidth; // 获得该容器的宽
        let eleH = element.offsetHeight; // 获得该容器的高
        // canvas.width = eleW * 2; // 将画布宽&&高放大两倍
        // canvas.height = eleH * 2;
        // canvas.style.width = eleW + 'px';
        // canvas.style.height = eleH + 'px';
        let context = canvas.getContext('2d');
        context.scale(2, 2);
        context.translate(-eleOffsetLeft - abs, -eleOffsetTop);
        const options = {
          useCORS: true, //允许图片跨域
          scale: 1.01, // 像素比
          // width: eleW,
          // height: eleH,
          // x: (window.innerWidth) / 2
          // allowTaint: false, //允许加载跨域的图片
          // tainttest: true, //检测每张图片都已经加载完成/
          // scrollX: 0,
          // scrollY: 0,
        };
        let canvasRes = await html2canvas(element, options);
        // 解决生成图片不完整的问题,在图片生成前，先把滚动条置顶
        window.pageYoffset = 0;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        let oImg = document.createElement('img');
        oImg.src = canvasRes.toDataURL('image/jpeg'); // 导出图片
        // oImg.onload = function () {};
        oImg.style.width = '100%';
        oImg.style.height = 32;
        oImg.crossOrigin = 'Anonymous';
        element.parentNode.replaceChild(oImg, element);
      }
      this.$nextTick(() => {
        this.reportHTML = contentDocument.innerHTML;
        this.fullscreenLoading = false;
      });
    },
    btnHTMLtoCanvas2() {
      this.fullscreenLoading = true;
      this.showBatchBtn = false
      let contentDocument = $.clone(this.$refs['reports']); //获取需要导出的标签
      let taskItemList = this.$refs['taskItemRef'] || [];
      let progressBarList = $('.progress-bar') || [];
      sessionStorage.oldCharts=JSON.stringify(this.charts);
      sessionStorage.oldForm=JSON.stringify(this.form);
      for (let index = 0; index < taskItemList.length; index++) {
        const item = taskItemList[index];
        item.showBtn = false;
      }
      // this.getProgressBarIMG(progressBarList,contentDocument); // !影响性能可以考虑注释

      this.$nextTick(() => {
        this.reportHTML = contentDocument.innerHTML;
        this.fullscreenLoading = false;
      });
    },
    async getProgressBarIMG(progressBarList, contentDocument) {
      try {
        // 进度条转换图片
        for (let index = 0; index < progressBarList.length; index++) {
          const element = progressBarList[index];
          let eleOffsetTop = element.offsetTop; // 获得该容器到文档顶部的距离
          let eleOffsetLeft = element.offsetLeft; // 获得该容器到文档最左的距离
          let abs = 0;
          let win_in = document.documentElement.clientWidth || document.body.clientWidth; // 获得当前可视窗口的宽度（不包含滚动条）
          let win_out = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）
          if (win_out > win_in) {
            // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
            abs = (win_out - win_in) / 2; // 获得滚动条宽度的一半
            // console.log(a, '新abs');
          }
          let canvas = document.createElement('canvas');
          let eleW = element.offsetWidth; // 获得该容器的宽
          let eleH = element.offsetHeight; // 获得该容器的高
          canvas.width = eleW * 2; // 将画布宽&&高放大两倍
          canvas.height = eleH * 2;
          canvas.style.width = 250 + 'px';
          canvas.style.height = eleH + 'px';
          let context = canvas.getContext('2d');
          context.scale(2, 2);
          context.translate(-eleOffsetLeft - abs, -eleOffsetTop);
          const options = {
            useCORS: true, //允许图片跨域
            scale: 1.01, // 像素比
            // width: eleW,
            // height: eleH,
            // x: (window.innerWidth) / 2
            // allowTaint: false, //允许加载跨域的图片
            // tainttest: true, //检测每张图片都已经加载完成/
            // scrollX: 0,
            // scrollY: 0,
          };
          let canvasRes = await html2canvas(element, options);
          // 解决生成图片不完整的问题,在图片生成前，先把滚动条置顶
          window.pageYoffset = 0;
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
          let oImg = document.createElement('img');
          oImg.src = canvasRes.toDataURL('image/jpeg'); // 导出图片
          // oImg.onload = function () {};
          oImg.style.width = 250;
          // oImg.style.height = 32;
          oImg.crossOrigin = 'Anonymous';
          element.parentNode.replaceChild(oImg, element);
        }
        this.$nextTick(() => {
          this.reportHTML = contentDocument.innerHTML;
          this.fullscreenLoading = false;
        });
      } catch (error) {
        console.log(error);
      }
    },
    //保存报告结果 fbt接口
    saveReportResult(reportResultContent) {
      let self = this;
      self.api
        .postJsonD('/ms-common-admin-cloud-service/zip/download/html-to-word', { html: this.getHTML(reportResultContent) })
        .then((res) => {
          this.fullscreenLoading = false;
          let blob = new Blob([res.data], { type: 'application/msword' });
          let fileName = `问卷分析报告_${this.currentSurver.surveyTitle}_${this.$moment(new Date()).format(
            'YYYYMMDD',
          )}`;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        })
        .catch(() => {
          self.fullscreenLoading = false;
        });
    },
    // bi导出word接口
    saveReportResult2(reportResultContent) {
      let self = this;
      self.fullscreenLoading = true;
      let param = {
        reportTemplateGuid: this.checkProEnv()
          ? '020a5cf094254c6aa64d53d7f710882c'
          : 'f893182503f5434383b919018ff8bf26',
        reportResultContent,
      };
      let loginUrl = reportRoute + `/${serverConfig.msReportConfigService}` + '/report-doc-template/save-report-result';
      fetch(loginUrl, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          Authorization: self.$store.state.token,
        },
        body: JSON.stringify(param),
      })
        .then(function (res) {
          return res.json();
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.code == '00000') {
            window.open(res.data);
          } else {
            self.$message.error(res.msg);
          }
        })
        .catch(() => {
          self.fullscreenLoading = false;
        });
    },
    saveReportResult3(reportResultContent) {
      let self = this;
      self.api
        .postJsonD(`${serverConfig.msReportConfigService}/report-doc-template/download/html-to-word`, {
          html: reportResultContent,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          let blob = new Blob([res.data], { type: 'application/msword' });
          let fileName = '问卷分析报告' + this.$moment(new Date()).format('YYYYMMDD');
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        })
        .catch(() => {
          self.fullscreenLoading = false;
        });
    },
    getHTML(reportResultContent) {
      let html = reportResultContent;
      html = html.replace(/"/g, "'");
      return html;
    },
    goBack() {
      let checkboxGroupList = [];
      let taskItemList = this.$refs.taskItemRef;
      if (taskItemList.length) {
        taskItemList.forEach((item) => {
          checkboxGroupList.push(item.checkboxGroup);
        });
      }
      this.showBatchBtn = true
      this.$emit('goBack', { checkboxGroupList });
    },
    checkProEnv() {
      return (
        location.href.indexOf('//scm-operation.csyaoly.com') > -1 ||
        location.href.indexOf('//scm-operation.cs4pl.com') > -1
      );
    },
  },
};
</script>

<style lang="less" scoped>
#report-content {
  background-color: #fff;
  width: 625px;
  margin: 0 auto;
}
.dialogCon {
  border-top: 1px solid #dcdee0;
  text-align: left;
  padding: 10px 20px;
}
.dialog-title {
  text-align: left;
  width: 240px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
.button-area2 {
  position: fixed;
  top: 51px;
  text-align: left;
  width: calc(99% - 245px);
  background: #fff;
  text-align: left;
  padding: 0 8px 8px 8px;
  background-color: #ffffff;
  border-radius: 6px 6px 0 0;
  z-index: 999;
  height: 80px;
}
.batch-btn {
  text-align: right;
  position: absolute;
  right: 10px;
  top: 0;
}
.toTop {
  border-radius: 10px;
  bottom: 70px;
  position: fixed;
  right: 30px;
  padding-top: 4px;
  z-index: 100;
  display: flex;
  flex-flow: column;
  color: #999;
  cursor: pointer;
}
.to-top-svg {
  fill: #999;
}
.toTop:hover {
  color: #4fa1a4;
  .to-top-svg {
    fill: #4fa1a4;
  }
}
.sort-input-box{
  width: 72px;
}
</style>

<style scoped>
/deep/.el-form-item{
  margin-bottom: 0;
}
/deep/.el-checkbox-button{
  width: 72px;
}
/deep/.el-checkbox-button__inner{
  width: 72px;
}
/deep/.el-dialog__footer {
  border-top: 1px solid #d9d9d9;
}
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/.el-dialog__header {
  padding: 10px 15px;
}
/deep/.my-loading .el-loading-spinner {
  width: calc(100% + 238px);
  top: 25%;
}
</style>
